import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NewRegistrationService } from 'src/app/services/new-registration.service';

@Component({
  selector: 'app-verificar-claves',
  templateUrl: './verificar-claves.component.html',
  styleUrls: []
})
export class VerificarClavesComponent implements OnInit {

  // I/O
  @Output() onValidacionExitosa: EventEmitter<any> = new EventEmitter<any>()
  @Output() onValidacionFallida: EventEmitter<string> = new EventEmitter<string>()

  private guid: string = ''
  PreContactForm: FormGroup;
  progressValidacion: boolean = false
  resultadoPreValidacionClave: any = null

  allowInteract: boolean = false

  mensajes = {
    showErrorValidacion: false,
    showTokenExpirado: false,
    tokenExpirado: ''
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private newRegistrationService: NewRegistrationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      param => {
        console.log('[REGISTER]', param.guid)
        this.guid = param.guid
        this.validateGuid(this.guid)
      },
    );

    this.createForm();
  }

  async validateGuid(guid: string) {
    const { Error, MensajeRetorno }: any = await this.newRegistrationService.ValidarGuid(guid).toPromise()
    this.allowInteract = true
    if (Error) {
      this.mensajes.showTokenExpirado = true
      this.mensajes.tokenExpirado = MensajeRetorno
    }
  }

  createForm() {
    this.PreContactForm = this.fb.group(
      {
        Clave: [
          '',
          [
            Validators.required,
            Validators.maxLength(16),
            Validators.minLength(3),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-$@$.$-$,$!%*?&])([A-Za-z\d-$@$!%*?&]|[^ ]){8,16}$/
            ),
          ],
        ],
        Clave2: [
          '',
          [
            Validators.required,
            Validators.maxLength(16),
            Validators.minLength(3),
          ],
        ]
      },
      {
        validators: [
          this.ClavesIguales('Clave', 'Clave2')
        ],
      }
    );
  }

  ClavesIguales(pass1Name: string, pass2Name: string) {
    return (formGroup: FormGroup) => {
      const pass1Control = formGroup.get(pass1Name);
      const pass2Control = formGroup.get(pass2Name);

      if (pass1Control.value === pass2Control.value) {
        pass2Control.setErrors(null);
      } else {
        pass2Control.setErrors({ noEsIgual: true });
      }
    };
  }

  async validarGuid() {
    this.clearMensajes()

    this.validateAllFormFields(this.PreContactForm);

    console.log('this.PreContactForm.valid', this.PreContactForm.valid, this.PreContactForm.value)
    console.log('Clave', this.PreContactForm.get('Clave').valid)
    console.log('Clave2', this.PreContactForm.get('Clave2').valid)


    if (!this.PreContactForm.valid)
      return

    this.progressValidacion = true
    this.resultadoPreValidacionClave = await this.newRegistrationService.ValidarGuid(this.guid).toPromise()
    this.progressValidacion = false
    const { Error, MensajeRetorno } = this.resultadoPreValidacionClave
    if (Error) {
      this.mensajes.showErrorValidacion = true
      this.onValidacionFallida.emit(MensajeRetorno)
      return
    }

    this.onValidacionExitosa.emit()
  }

  clearMensajes() {
    if (!this.mensajes) return
    this.mensajes.showErrorValidacion = false
    this.mensajes.showTokenExpirado = false
    this.mensajes.tokenExpirado = ''
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  returnToLogin() {
    this.router.navigateByUrl('/');
  }

}
